import { useEffect, useState } from "react";

function TypedText({ text }: { text: string }) {
  const [typedText, setTypedText] = useState("");

  useEffect(() => {
    setTypedText("");
  }, [text]);

  useEffect(() => {
    if (typedText === text) {
      return;
    }

    const timeout = setTimeout(() => {
      setTypedText((previous) =>
        previous.length < text.length
          ? text.slice(0, previous.length + 1)
          : previous,
      );
    }, 400 / text.length);

    return () => {
      clearTimeout(timeout);
    };
  }, [text, typedText]);

  return <span>{typedText}</span>;
}

export default TypedText;
